<template>
<v-form ref="form" lazy-validation v-model="valid" class="pa-5">
    <v-layout wrap="true">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">วันที่เริ่ม:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">วันที่เริ่ม:</p>
        </v-flex>
        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog=false">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-flex xs12 md3 v-if="editState">
            <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="requiredRule" outlined required v-model="computedDateFormattedStartDate" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker :rules="requiredRule" v-model="editItem.startDatePicker" no-title required @input="menu1 = false" @change="startDateChange"></v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex xs12 md3 class="d-flex align-center" v-else @dblclick="verifyEditState">
            {{ formatDate(editItem.startDatePicker) || '-' }}
        </v-flex>

        <v-flex xs12 md1 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">วันที่จบโปรแกรม:</p>
        </v-flex>
        <v-flex xs12 md1 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">วันที่จบโปรแกรม:</p>
        </v-flex>
        <!-- <v-flex xs12 md3 mt-4>
            {{ formatDate(editItem.endDatePicker) || '-' }}
        </v-flex> -->
        
        <v-flex xs12 md3 v-if="editState">
            <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="requiredRule" outlined required v-model="computedDateFormattedEndDate" hint="DD/MM/YYYY" persistent-hint v-bind="attrs" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker :rules="requiredRule" v-model="editItem.endDatePicker" no-title required @input="menu2 = false" :min="endDateMin"></v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex xs12 md3 class="d-flex align-center" v-else @dblclick="verifyEditState">
            {{ formatDate(editItem.endDatePicker) || '-' }}
        </v-flex>
    </v-layout>

    <v-layout wrap="true">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">Onsite Number:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">Onsite Number:</p>
        </v-flex>
        <v-flex xs12 md1 v-if="editState">
            <v-text-field :rules="requiredRule" v-model="editItem.memberOnsite" outlined type="number" min="2" @change="memberOnsiteChange"></v-text-field>
        </v-flex>
        <v-flex xs12 md3 class="d-flex align-center" v-else @dblclick="verifyEditState">
            {{ editItem.memberOnsite || 2 }}
        </v-flex>
    </v-layout>

    <v-layout wrap="true">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">เป้าหมาย:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">เป้าหมาย:</p>
        </v-flex>
        <v-flex xs12 md7 v-if="editState">
            <v-text-field :rules="requiredRule" v-model="editItem.memberTarget" outlined></v-text-field>
        </v-flex>
        <v-flex xs12 md3 class="d-flex align-center" v-else @dblclick="verifyEditState">
            {{ editItem.memberTarget|| '-' }}
        </v-flex>
    </v-layout>

    <v-layout wrap="true">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">แผนการปรับเปลี่ยน:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">แผนการปรับเปลี่ยน:</p>
        </v-flex>
        <v-flex xs12 md7 v-if="editState">
            <v-textarea :rules="requiredRule" v-model="editItem.memberPlan" outlined></v-textarea>
        </v-flex>
        <v-flex xs12 md8 class="d-flex align-center" v-else @dblclick="verifyEditState">
            {{ editItem.memberPlan || '-' }}
        </v-flex>
    </v-layout>

    <v-layout v-if="editItem.isCancelProgram">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">ยกเลิกโปรแกรม:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">ยกเลิกโปรแกรม:</p>
        </v-flex>
        <v-flex xs12 md8 class="d-flex align-center">
            {{ editItem.cancelDatePicker || '-' }}
        </v-flex>
    </v-layout>

    <v-layout v-if="enableEndProgram">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">สรุปข้อมูลและแผนในอนาคต:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">สรุปข้อมูลและแผนในอนาคต:</p>
        </v-flex>
        <v-flex xs12 md8 class="d-flex align-center">
            {{ editItem.programSummary || '-' }}
        </v-flex>
    </v-layout>

    <v-layout v-if="editItem.isCancelProgram">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">สาเหตุ:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">สาเหตุ:</p>
        </v-flex>
        <v-flex xs12 md8 class="d-flex align-center">
            {{ editItem.programResult || '-' }}
        </v-flex>
    </v-layout>

    <v-layout v-if="enableEndProgram">
        <v-flex xs12 md2 class="d-none d-md-inline">
            <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">ผลสำเร็จ:</p>
        </v-flex>
        <v-flex xs12 md2 class="d-md-none">
            <p class="text-subtitle-1 text-md-right mr-md-3">ผลสำเร็จ:</p>
        </v-flex>
        <v-flex xs12 md8 class="d-flex align-center">
            {{ editItem.programResult || '-' }}
        </v-flex>
    </v-layout>

    <v-layout wrap="true" v-if="allowToManage">
        <v-flex xs12 md9 text-right>
            <!-- <v-btn d-flex color="blue darken-1" text @click="verifyEditState" v-if="verifyEditState && !editState"> edit program </v-btn> -->

            <v-btn d-flex color="blue darken-1" text @click="editItem = beforeEditItem; editState = false;" v-if="editState"> cancel </v-btn>
            <v-btn color="blue darken-1" text @click="submit" v-if="editState">
                Update
            </v-btn>
        </v-flex>
    </v-layout>
</v-form>
</template>

<script>
import formatData from "../utils/formatData";
import getProgramMemberInfo from "../data/getProgramMemberInfo";
import setProgramInfo from "../data/setProgramInfo";
import moment from "moment";
export default {
    data() {
        return {
            //to validate from
            valid: false,
            requiredRule: [
                (value) => !!value || "Required."
            ],
            dialog: false,
            title: "",
            menu1: false,
            menu2: false,
            menu3: false,
            editItem: {
                action: "memberInfo",
                startDatePicker: "",
                endDatePicker: "",
                startDateText: "-",
                endDateText: "-",
                memberOnsite: 2,
                memberPlan: "",
                memberTarget: "",
                programResult: "",
                programSummary: ""
            },
            beforeEditItem: {},
            editState: false,
            enableEndProgram: false
            // programResultOption: [
            //     'บรรลุเป้าหมายที่กำหนด',
            //     'ยังไม่บรรลุเป้าหมาย แต่มีการเปลี่ยนแปลงชัดเจน',
            //     'ยังไม่บรรลุเป้าหมาย แต่มีพฤติกรรมสุขภาพเปลี่ยนแปลงชัดเจน',
            //     'ไม่มีการเปลี่ยนแปลงที่ชัดเจน'
            // ]
        };
    },
    created() {
        (async () => {
            this.editItem = await getProgramMemberInfo(this.id, this.uid);
            this.enableEndProgram = this.editItem.enableEndProgram;
            this.endDateMin = moment(this.editItem.startDatePicker + ' 00:00:00').add(1, 'M').format('YYYY-MM-DD');
        })();
    },
    computed: {
        id() {
            return this.$attrs.id;
        },
        uid() {
            return this.$attrs.uid;
        },
        allowToManage() {
            return this.$attrs.allowToManage;
        },
        computedDateFormattedStartDate() {
            return this.formatDate(this.editItem.startDatePicker);
        },
        computedDateFormattedEndDate() {
            return this.formatDate(this.editItem.endDatePicker);
        }

    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        verifyEditState() {
            if (this.allowToManage) {
                this.editState = true;
                this.beforeEditItem = {
                    startDatePicker: this.editItem.startDatePicker,
                    endDatePicker: this.editItem.endDatePicker,
                    memberPlan: this.editItem.memberPlan,
                    memberTarget: this.editItem.memberTarget,
                };
            }
        },
        startDateChange() {
            this.endDateMin = moment(this.editItem.startDatePicker + ' 00:00:00').add(1, 'M').format('YYYY-MM-DD');
            this.editItem.endDate = this.endDateMin;
            this.editItem.endDatePicker = this.endDateMin;
        },
        memberOnsiteChange() {
            if( this.editItem.memberOnsite < 2 ){
                this.editItem.memberOnsite = 2;
            }
        },
        submit() {
            (async () => {
                //to validate from before submit
                await this.$refs.form.validate();
                if (this.valid) {
                    (async () => {
                        await setProgramInfo({
                            action: "memberInfo",
                            startDate: new Date(this.editItem.startDatePicker + ' 00:00:00'),
                            endDate: new Date(this.editItem.endDatePicker + ' 00:00:00'),
                            memberOnsite: this.editItem.memberOnsite*1,
                            memberTarget: this.editItem.memberTarget,
                            memberPlan: this.editItem.memberPlan,
                        }, this.id, this.uid);
                        this.editState = false;
                        this.dialog = true;
                        this.toGetOverviewData();
                    })();
                }
            })();
        },
        toGetOverviewData(){
            this.$emit('toGetOverviewData');
        }
    }
};
</script>
